class HeroSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.hero-slider__track');
    this.slides = this.querySelectorAll('.hero-slider__slide');
    this.dots = this.querySelectorAll('.hero-slider__dot');
    this.current = 0;
    this.total = this.slides.length;
    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed) || 5000;
    this.timer = null;

    if (this.total <= 1) return;

    this.querySelector('.hero-slider__arrow--prev')
      ?.addEventListener('click', () => { this.go(this.current - 1); this.resetTimer(); });
    this.querySelector('.hero-slider__arrow--next')
      ?.addEventListener('click', () => { this.go(this.current + 1); this.resetTimer(); });

    this.dots.forEach((dot, i) =>
      dot.addEventListener('click', () => { this.go(i); this.resetTimer(); })
    );

    if (this.autoplay) this.startTimer();

    this.addEventListener('mouseenter', () => this.stopTimer());
    this.addEventListener('mouseleave', () => { if (this.autoplay) this.startTimer(); });
  }

  go(index) {
    this.current = ((index % this.total) + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.current));
    this.dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === this.current);
      d.setAttribute('aria-selected', String(i === this.current));
    });
  }

  startTimer() {
    this.timer = setInterval(() => this.go(this.current + 1), this.speed);
  }

  stopTimer() {
    clearInterval(this.timer);
    this.timer = null;
  }

  resetTimer() {
    this.stopTimer();
    if (this.autoplay) this.startTimer();
  }
}

class ProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.product-carousel__track');
    this.cards = this.querySelectorAll('.product-card');
    this.current = 0;

    if (this.cards.length === 0) return;

    this.querySelector('.product-carousel__arrow--prev')
      ?.addEventListener('click', () => this.go(this.current - 1));
    this.querySelector('.product-carousel__arrow--next')
      ?.addEventListener('click', () => this.go(this.current + 1));
  }

  get visible() {
    return window.innerWidth < 768 ? 1 : 4;
  }

  go(index) {
    const max = Math.max(0, this.cards.length - this.visible);
    this.current = Math.min(Math.max(index, 0), max);
    const cardWidth = this.cards[0]?.offsetWidth || 0;
    const gap = parseInt(getComputedStyle(this.track).gap) || 16;
    this.track.style.transform = `translateX(-${this.current * (cardWidth + gap)}px)`;
  }
}

if (!customElements.get('hero-slider')) customElements.define('hero-slider', HeroSlider);
if (!customElements.get('product-carousel')) customElements.define('product-carousel', ProductCarousel);
